/* Evalinne – "À propos" page: layout, photo collage, icons, reveal (theme only) */
(function(){
  function run(){
    var r=document.querySelector('.ev-about'); if(!r||r.__eva) return; r.__eva=1;
    document.body.classList.add('eva-page');
    var hero=r.querySelector('.ev-about__hero');
    if(hero){
      var txt=document.createElement('div'); txt.className='eva-txt';
      while(hero.firstChild) txt.appendChild(hero.firstChild);
      var ctas=document.createElement('div');ctas.className='eva-ctas';
      ctas.innerHTML='<a class="eva-btn p" href="/collections/all">Découvrir la collection <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M13 6l6 6-6 6"/></svg></a><a class="eva-btn s" href="#eva-story">Notre histoire</a>';
      txt.appendChild(ctas);
      var imgs=(window.evAboutImgs||[]).filter(Boolean);
      function ph(cls,i){return '<div class="eva-ph '+cls+'">'+(imgs[i]?'<img src="'+imgs[i]+'" alt="" loading="eager">':'')+'</div>';}
      var col=document.createElement('div');col.className='eva-collage';
      col.innerHTML=ph('a',0)+ph('b',1)+ph('c',2)+'<div class="eva-badge"><b>+5 000</b><span>clientes</span></div>';
      var grid=document.createElement('div');grid.className='eva-in eva-hero';
      grid.appendChild(txt);grid.appendChild(col);hero.appendChild(grid);
    }
    var story=r.querySelector('.ev-about__story');
    if(story){
      story.id='eva-story';
      var eb=story.querySelector('.ev-about__story-eyebrow'), h2=story.querySelector('h2');
      var L=document.createElement('div');L.className='eva-story-l';
      if(eb)L.appendChild(eb); if(h2)L.appendChild(h2);
      var q=document.createElement('span');q.className='eva-quote';q.textContent='“';L.appendChild(q);
      var R=document.createElement('div');R.className='eva-story-r';
      while(story.firstChild) R.appendChild(story.firstChild);
      var p1=R.querySelector('p'); if(p1)p1.classList.add('eva-lead');
      story.appendChild(L);story.appendChild(R);
    }
    var vt=r.querySelector('.ev-about__values-title');
    if(vt){var e=document.createElement('span');e.className='eva-eyebrow';e.textContent='Nos valeurs';vt.parentNode.insertBefore(e,vt);}
    var ic=[
      '<path d="M12 3l1.8 4.6L18.5 9l-4.7 1.4L12 15l-1.8-4.6L5.5 9l4.7-1.4z"/><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"/>',
      '<path d="M4 15c3-1 5-4 7-8 1 4 4 7 9 8"/><path d="M3 19h18"/><path d="M7 15c-.5 1.5-.5 2.8 0 4"/>',
      '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>',
      '<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/>',
      '<rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>',
      '<path d="M4 5h16v11H9l-5 4V5z"/><path d="M8 10h8M8 13h5"/>'
    ];
    r.querySelectorAll('.ev-about__value-icon').forEach(function(el,i){el.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">'+(ic[i]||ic[0])+'</svg>';});
    var sel=['.eva-txt','.eva-collage','.ev-about__stat','.eva-story-l','.eva-story-r','.eva-eyebrow','.ev-about__values-title','.ev-about__value-card','.ev-about__promise','.ev-about__cta'];
    if(!('IntersectionObserver' in window)||(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    r.classList.add('eva-js');
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
    sel.forEach(function(s){r.querySelectorAll(s).forEach(function(el,i){el.classList.add('eva-r');el.style.setProperty('--d',(i%3)*0.1+'s');io.observe(el);});});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
